// Product listing JavaScript

// Facet search parse search URL
const parseSearchUrl = (event) => {
  if (event.target.dataset.searchUrl !== undefined) {
    return event.target.dataset.searchUrl;
  }
  if ($(event.target).parent()[0].dataset.searchUrl === undefined) {
    throw new Error('Can not parse search URL');
  }
  return $(event.target).parent()[0].dataset.searchUrl;
};

// Update facet search and show loader
const updateFacets = (url) => {
  $('#loader').show();
  prestashop.emit('updateFacets', url);
}

// Update listing page and remove loader
const updateProductListDOM = (data) => {
  $('#search_filters').replaceWith(data.rendered_facets);
  $('#js-active-search-filters').replaceWith(data.rendered_active_filters);
  $('#js-product-list-top').replaceWith(data.rendered_products_top);
  $('#js-product-list').replaceWith(data.rendered_products);
  $('#js-product-list-bottom').replaceWith(data.rendered_products_bottom);
  if (data.rendered_products_header) {
    $('#js-product-list-header').replaceWith(data.rendered_products_header);
  }
  $('#loader').hide();
}

// Scroll to top in product listing
window.scrollToTop = () => {
  $('body,html').animate({
    scrollTop : 0                       // Scroll to top of body
  }, 500);
}

$(document).ready(() => {
  // Facet search listeners
  $('body').on('change', '#search_filters input[data-search-url]', function (event) {
    updateFacets(parseSearchUrl(event));
  });
  $('body').on('click', '.js-search-filters-clear-all', function (event) {
    updateFacets(parseSearchUrl(event));
  });
  $('body').on('click', '.js-search-link', function (event) {
    event.preventDefault();
    updateFacets($(event.target).closest('a').get(0).href);
  });
  $('body').on('change', '#search_filters select', function (event) {
    const form = $(event.target).closest('form');
    updateFacets('?' + form.serialize());
  });
  $('body').on('change', '#sort-select', function (event) {
    updateFacets(event.target.value);
  });
  prestashop.on('updateProductList', (data) => {
    updateProductListDOM(data);
  });

  /* Anteprima del prodotto */
  prestashop.on('clickQuickView', function (elm) {
    let data = {
      'action': 'quickview',
      'id_product': elm.dataset.idProduct,
      'id_product_attribute': elm.dataset.idProductAttribute,
    };
    $.post(prestashop.urls.pages.product, data, null, 'json').then(function (resp) {
      $('body').append(resp.quickview_html);
      let productModal = $(`#quickview-modal-${resp.product.id}-${resp.product.id_product_attribute}`);
      productModal.modal('show');
      //productConfig(productModal);
      productModal.on('hidden.bs.modal', function () {
        productModal.remove();
      });
    }).fail((resp) => {
      prestashop.emit('handleError', {eventType: 'clickQuickView', resp: resp});
    });
  });

});


// WEBPACK FOOTER //
// ./js/listing.js